import React from 'react';
import ReactDOM from 'react-dom';
import "../src/assets/vendor/bootstrap/css/bootstrap.min.css";
import "../src/assets/vendor/font-awesome/css/all.min.css";
import "../src/assets/vendor/bootstrap-select/css/bootstrap-select.min.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import "../src/assets/css/style.css";

ReactDOM.render(
    <React.StrictMode>
    <MuiPickersUtilsProvider utils={MomentUtils}>
    <App/>
    </MuiPickersUtilsProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
